import { createSlice } from "@reduxjs/toolkit";

const UserSlice = createSlice({
  name: "User",
  initialState: {
    userName: "",
    userEmail: "",
    userPhone: "",
    userAddress: "",
    userCity: "",
    userState: "",
    userCountry: "",
    country: [],
    state: [],
    city: [],
    location: [],
    locationId: "",
    userExist: false,
    delivery: "",
    userLocation: "",
    order: [],
    viewItems: false,
    notes: {},
  },
  reducers: {
    setNotes: (state, action) => {
      state.notes = action.payload;
    },
    setUserName: (state, action) => {
      state.userName = action.payload;
    },
    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
      localStorage.setItem("user-email", action.payload);
    },
    setUserPhone: (state, action) => {
      state.userPhone = action.payload;
    },
    setUserAddress: (state, action) => {
      state.userAddress = action.payload;
    },
    setUserCity: (state, action) => {
      state.userCity = action.payload;
    },
    setUserState: (state, action) => {
      state.userState = action.payload;
    },
    setUserCountry: (state, action) => {
      state.userCountry = action.payload;
    },
    setUserExist: (state, action) => {
      state.userExist = action.payload;
    },
    setDelivery: (state, action) => {
      state.delivery = action.payload;
    },
    setCountry: (state, action) => {
      state.country = action.payload;
    },
    setCity: (state, action) => {
      state.city = action.payload;
    },
    setState: (state, action) => {
      state.state = action.payload;
    },
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    setLocationId: (state, action) => {
      state.locationId = action.payload;
    },
    setUserLocation: (state, action) => {
      state.userLocation = action.payload;
    },
    setOrder: (state, action) => {
      state.order = action.payload;
    },
    setViewItems: (state, action) => {
      state.viewItems = action.payload;
    },
  },
});

export const UserActions = UserSlice.actions;

export default UserSlice;
